import React from 'react';

import injectGoBack from './helper/inject-go-back';

const BackTo = injectGoBack(
	({goBackTo, children, backPath}) => (
		<a onClick={goBackTo} href={backPath}>
			{children}
		</a>
	)
);

export default BackTo;
